import type { CSSProperties, HTMLAttributes } from 'react';
import { clsx } from '../clsx';
import styles from './Skeleton.module.css';

export interface SkeletonProps extends HTMLAttributes<HTMLSpanElement> {
  /** `line` is a 12 px text line, `block` a card-shaped area, `circle` an avatar. */
  variant?: 'line' | 'block' | 'circle' | undefined;
  width?: number | string | undefined;
  height?: number | string | undefined;
}

/** Loading placeholder of the screens (Deal-Pipeline 14): `--surface-quiet`, pulsing opacity, static with reduced motion. */
export function Skeleton({ variant = 'line', width, height, className, style, ...rest }: SkeletonProps) {
  const size: CSSProperties = {};
  if (width !== undefined) size.width = width;
  if (height !== undefined) size.height = height;
  if (variant === 'circle' && width !== undefined && height === undefined) size.height = width;
  return (
    <span
      aria-hidden="true"
      className={clsx(styles.skeleton, styles[variant], className)}
      style={{ ...size, ...style }}
      {...rest}
    />
  );
}
